import { i18n } from "@/boot/i18n";
import { QUESTION_TYPE } from "@/consts/survey";

export const validateSurveyLanguage = (survey) => {
  const meta = {
    items: []
  };

  // Validate language translations
  let validLang = true;

  for (let i = 0; i < survey.items.length; i++) {
    const item = survey.items[i];
    if (survey.lang.length !== 0) {
      // Only if user select other languages
      for (let l = 0; l < survey.lang.length; l++) {
        const lang = survey.lang[l];
        if (item.type === QUESTION_TYPE.IMAGE) {
          // Image don't have language settings
          continue;
        }
        if (item.question[lang] === undefined || item.question[lang] === "") {
          validLang = false;
          meta.items.push(i);
          continue;
        }

        if (item.comment_question && item.comment_question[survey.default_lang]) {
          if (item.comment_question[lang] === undefined || item.comment_question[lang] === "") {
            validLang = false;
            meta.items.push(i);
            continue;
          }
        }
        if (item.detractor_comment_question && item.detractor_comment_question[survey.default_lang]) {
          if (item.detractor_comment_question[lang] === undefined || item.detractor_comment_question[lang] === "") {
            validLang = false;
            meta.items.push(i);
            continue;
          }
        }
        if (item.neutral_comment_question && item.neutral_comment_question[survey.default_lang]) {
          if (item.neutral_comment_question[lang] === undefined || item.neutral_comment_question[lang] === "") {
            validLang = false;
            meta.items.push(i);
            continue;
          }
        }
        if (item.promoter_comment_question && item.promoter_comment_question[survey.default_lang]) {
          if (item.promoter_comment_question[lang] === undefined || item.promoter_comment_question[lang] === "") {
            validLang = false;
            meta.items.push(i);
            continue;
          }
        }
        if (item.button_subtitle_min && item.button_subtitle_min[survey.default_lang]) {
          if (item.button_subtitle_min[lang] === undefined || item.button_subtitle_min[lang] === "") {
            validLang = false;
            meta.items.push(i);
            continue;
          }
        }
        if (item.button_subtitle_max && item.button_subtitle_max[survey.default_lang]) {
          if (item.button_subtitle_max[lang] === undefined || item.button_subtitle_max[lang] === "") {
            validLang = false;
            meta.items.push(i);
          }
        }
        if (item.options) {
          item.options.forEach((option) => {
            if (!option[lang]) {
              validLang = false;
              meta.items.push(i);
            }
          });
        }
        // Composite metrics
        if (item.items && item.items.length > 0) {
          if (item.composite_question[lang] === undefined || item.composite_question[lang] === "") {
            validLang = false;
            meta.items.push(i);
            continue;
          }
          let valid = validateLanguageSubitem(lang, item.items);
          if (!valid) {
            validLang = false;
            meta.items.push(i);
          }
        }
      }
    }
  }
  if (!validLang) {
    return {
      field: "surveyItem",
      message: i18n.t("survey.messages.lang_error"),
      meta
    };
  }
  return null;
};

export function validateLanguageSubitem(lang, subitems) {
  let valid = true;
  for (let k = 0; k < subitems.length; k++) {
    const subitem = subitems[k];
    if (subitem.question[lang] === undefined || subitem.question[lang] === "") {
      valid = false;
      break;
    }
    if (subitem.items && subitem.items.length > 0) {
      valid = validateLanguageSubitem(lang, subitem.items);
      if (!valid) {
        break;
      }
    }
  }
  return valid;
}

export const validateImageItem = (survey) => {
  const meta = {
    items: []
  };
  for (let i = 0; i < survey.items.length; i++) {
    const surveyItem = survey.items[i];
    if (surveyItem.type === QUESTION_TYPE.IMAGE && surveyItem.url === "") {
      meta.items.push(i);
    }
  }
  if (meta.items.length) {
    return {
      field: "surveyItem",
      meta,
      message: i18n.t("survey.messages.images_without_image")
    };
  }

  return null;
};

export const validateEmptyItems = (survey) => {
  const questions = survey.items.filter(
    (item) => item.type !== QUESTION_TYPE.LABEL && item.type !== QUESTION_TYPE.IMAGE
  );
  if (questions.length === 0) {
    return {
      field: "surveyItem",
      message: i18n.t("survey.messages.minimun_question_error")
    };
  }
  return null;
};

export const validateSurveyTeams = (teamsPermission, userTeams) => {
  const userTeamsSelected = teamsPermission.filter((t) => {
    return userTeams.includes(t);
  });

  if (!teamsPermission.length || !userTeamsSelected.length) {
    return {
      field: "teams",
      message: i18n.t("survey.messages.teams_error")
    };
  }

  return null;
};
